export default __webpack_public_path__ + "static/media/Shemite Wayfarer Belt.9701cce4.jpg";